export default __webpack_public_path__ + "static/media/spanner.a949ce3a.png";